export default "__VITE_ASSET__yI1eUhiP__"